import { api } from 'app/config/apiConfig';
import { Pagination } from 'app/types/common';
import { BaseScale, IncomeStatisticsObject } from '../model/types';

interface Params {
  warehouseId?: string | string[];
  startDate?: boolean;
  endDate?: boolean;
  isApplicable?: boolean;
  scale?: BaseScale;
}

export const getIncomeStatisticsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getIncomeStatistics: build.query<Pagination<IncomeStatisticsObject>, Params>({
      query: (args) => ({
        url: '/warehouses/statistics/income',
        params: args,
      }),
    }),
  }),
});

export const { useGetIncomeStatisticsQuery } = getIncomeStatisticsApi;
